<template>
  <el-dialog
    :visible.sync="modalShow"
    center
    top="4vh"
    append-to-body
    modal-append-to-body
    width="960px"
  >
    <div v-if="app.user.termAccept==0">
      <div>
        <div style="height: 480px;width: 900px;">
          <div>
            <div class="d-flex justify-content-center"><h3>Salework Zalo - Thông báo</h3></div>
            <div style="margin-top: 40px"></div>
            <div class="d-flex justify-content-center w-100">

            </div>
            <div style="word-break: break-word !important;margin-left: 20px" class="font-size-20 px-3">
              <div class="font-icon-16 fw-bold"></div>
              <div class="mt-2">- Cảm ơn bạn đã đăng ký dịch vụ.</div>
              <div class="mt-1">- Để tiếp tục sử dụng, vui lòng đọc và đồng ý với những <a target="_blank" class="text-primary text-decoration-underline"
                                 href="https://salework.net/dieu-khoan-su-dung-salework-zalo/">điều khoản sử dụng</a> của Salework Zalo.
              </div>
              <div class="mt-1">- Quý khách cũng nên tham khảo để nâng cấp tài khoản <a target="_blank"
                                                                                        class="text-primary fw-bold"
                                                                                        href="https://business.zalo.me/">
                Zalo Business</a> để phục vụ công việc
                kinh
                doanh của mình một cách tốt hơn.<br />
                - Salework cũng cung cấp miễn phí tính năng quản trị Zalo OA(<a target="_blank"
                                                                                class="text-primary fw-bold"
                                                                                href="https://oa.zalo.me/home"> Zalo
                  Official Account</a> - phù hợp cho các doanh nghiệp cần CSKH) thông qua API chính thức của Zalo trên
                <a
                  href="https://chat.salework.net/" target="_blank" class="text-primary fw-bold"> Salework Chat</a>
                cho
                tất cả các tài khoản đã thanh toán Salework Zalo qúy khách có thể tham khảo và sử dụng.
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex justify-content-end">
        <el-checkbox v-model="accept" class="mt-2">Tôi đồng ý với các điều khoản và tiếp tục sử dụng</el-checkbox>
        <el-button :disabled="!accept" type="primary" class="mx-2" @click="termAccept()"><span
          class="mx-3">Xác nhận</span></el-button>
      </div>
    </div>
    <div v-else>
      <div style="height: 480px;width: 900px;">
        <div>
          <div class="d-flex justify-content-center"><h3>Salework Zalo - Thông báo</h3></div>
          <div style="margin-top: 40px"></div>
          <div class="d-flex justify-content-center w-100">

          </div>
          <div style="word-break: break-word !important;margin-left: 20px" class="font-size-20 px-3">
            <div class="font-icon-16 fw-bold"></div>
            <div class="mt-2">- Tài khoản của quý khách hiện giờ không thể sử dụng Salework Zalo. Vui lòng <a
              target="_blank"
              class="text-primary fw-bold"
              href="https://salework.net/billing/bill-create?appName=ZALO">nâng cấp tài khoản</a> hoặc liên hệ nhân viên kinh doanh để hỗ trợ.
            </div>
            <div class="mt-1">- Quý khách có thể tham khảo nâng cấp tài khoản <a target="_blank"
                                                                                 class="text-primary fw-bold"
                                                                                 href="https://business.zalo.me/">
              Zalo Business</a> để phục vụ công việc
              kinh
              doanh của mình một cách tốt hơn.<br />
              - Salework cũng cung cấp miễn phí tính năng quản trị Zalo OA(<a target="_blank"
                                                                              class="text-primary fw-bold"
                                                                              href="https://oa.zalo.me/home"> Zalo
                Official Account</a> - phù hợp cho các doanh nghiệp cần CSKH) thông qua API chính thức của Zalo trên
              <a
                href="https://chat.salework.net/" target="_blank" class="text-primary fw-bold"> Salework Chat</a>
              cho
              tất cả các tài khoản đã thanh toán Salework Zalo qúy khách có thể tham khảo và sử dụng.
            </div>
            <div>
              <div>Hotline : <span class="text-decoration-underline text-primary">1900 633 841</span></div>
              <div>Email : <span class="text-decoration-underline text-primary">Salework@esbt.vn</span></div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </el-dialog>
</template>

<script>
export default {
  name: "TermAcceptPopup",
  data() {
    return {
      modalShow: true,
      accept: false
    };
  },
  methods: {
    termAccept() {
      this.$http.get("/api/user/termAccept").then(() => {
        location.reload();
      });
    }
  }
};
</script>

<style scoped>

</style>
